import { stakeholderService } from '../services'

export default (clientId, rut, response, lang) => {
	return new Promise(resolve => {
		stakeholderService.forgotUser(clientId, rut, response, lang)
			.then(response => {
				if(response) resolve({ success: true, data: response.data })
			})
			.catch(error => {
				if(error && error.response) resolve({ success: false, data: error.response.data })
			})
	})
}
